import {inject, provideAppInitializer} from '@angular/core';
import {OAuthService, OAuthStorage} from 'angular-oauth2-oidc';
import {environment} from '../../environments/environment';
import {COOKIE_CONSENT, getCookie} from '../config/cookies.config';

export const authInitProvider = provideAppInitializer(() => {
  if (!getCookie(COOKIE_CONSENT)) {
    return Promise.resolve();
  }

  const oauthService = inject(OAuthService);

  oauthService.configure(environment.authConfig);
  oauthService.timeoutFactor = 0.75;

  return oauthService.loadDiscoveryDocumentAndLogin()
    .then(loggedIn => {
      if (loggedIn) {
        oauthService.setupAutomaticSilentRefresh(null, 'access_token');
      }
    })
    .catch(() => {});
});
